import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

const TOKEN_KEY = environment.storageToken;
const URL = environment.apiUrl;
@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private http: HttpClient) {}

  getToken() {
    let storage = null;

    if (localStorage.getItem(TOKEN_KEY)) {
      storage = localStorage;
    }

    if (sessionStorage.getItem(TOKEN_KEY)) {
      storage = sessionStorage;
    }

    if (storage) {
      let credentials = JSON.parse(storage.getItem(TOKEN_KEY) || '{}');
      let token = credentials.token;
      return token;
    }
  }

  private getHeaders() {
    const token = this.getToken();

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return headers;
  }

  getUsersDT(dataTablesParameters: any) {
    const headers = this.getHeaders();
    return this.http.post(`${URL}/users/datatable`, dataTablesParameters, {
      headers,
    });
  }
  public addUser(data: any) {
    const headers = this.getHeaders();
    return this.http.post(`${URL}/users`, data, { headers });
  }

  public editUser(data: any, id: number) {
    const headers = this.getHeaders();
    return this.http.put(`${URL}/users/${id}`, data, { headers });
  }
  public deleteUser(id: number) {
    const headers = this.getHeaders();
    return this.http.delete(`${URL}/users/${id}`, { headers });
  }
}
